<template>
    <v-dialog v-model="dialog" max-width="430" :fullscreen="$vuetify.breakpoint.xs">
        <v-card class="py-8 px-11">
            <h2 class="text-center">Are you sure?</h2>
            <p class="text-center font-weight-bold mt-3">If you delete this user will be removed all related data</p>
            <v-card-actions class="d-flex justify-center">
                <v-btn class="green white--text mr-4" type="submit" :loading="loadingRequest" @click="deleteUser">Agree</v-btn>
                <v-btn class="transparent green--text ml-4" @click="dialog = false">Disagree</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: ['user_id'],
        data(){
            return {
                dialog: false,
                loadingRequest: false,
            }
        },
        methods: {
            deleteUser(){
                this.loadingRequest = true;
                this.$apiAdmin('users').delete(this.user_id)
                    .then(() => {
                        if(this.$route.name === 'AdminStudentInfo'){
                            this.$router.go(-1);
                        }else{
                            this.$parent.$emit('getData');
                        }
                        this.$store.dispatch('alert', {type: 1, message: 'Successfully deleted.'});
                    }).finally(() => {
                    this.loadingRequest = false;
                    this.dialog = false;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../scss/components/dialog";
</style>